import { render } from "./RegisterForm.vue?vue&type=template&id=ff6d0f2e&scoped=true"
import script from "./RegisterForm.vue?vue&type=script&lang=js"
export * from "./RegisterForm.vue?vue&type=script&lang=js"

import "./RegisterForm.vue?vue&type=style&index=0&id=ff6d0f2e&scoped=true&lang=css"
import "./RegisterForm.vue?vue&type=style&index=1&id=ff6d0f2e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6d0f2e"]])

export default __exports__